export const TITLE = 'Apply for the Approval of a Program in a Foreign Country';
export const SUBTITLE =
  'Application for approval of a program in a foreign country (VA Form 22-0976)';

export const INSTITUTION_TYPES = {
  PUBLIC: 'Public institution',
  'FOR PROFIT': 'Private for profit institution',
  PRIVATE: 'Private non profit institution',
};
